import { Component, OnInit } from '@angular/core';
import {BooKingservice} from "../../booking/booking.service";

@Component({
  selector: 'app-inscription-end',
  templateUrl: './inscription-end.component.html',
  styleUrls: ['./inscription-end.component.css']
})
export class InscriptionEndComponent implements OnInit {
  currenteventUrl:any;
  constructor(private bookingservice:BooKingservice) { }

  ngOnInit() {
    this.currenteventUrl =  this.bookingservice.retrieve('currenteventUrl');
    //this.bookingservice.removeItem('inscriptionIframe');
  }

  Retour() {
    window.location.href = this.currenteventUrl;
  }

}
